import { app } from '../../../app.module'
app.component('memoCardAccount', {
  bindings: {
    memoCount: '=',
    accountData: '=',
  },
  template: require('./memo-card-account.pug')(),
})
